import React, { useState, useEffect } from 'react'
import { Card, CardMedia, Button, Typography } from '@material-ui/core/'

import DownloadIcon from '@mui/icons-material/Download'
import { saveAs } from 'file-saver'
import videothumbnail from '../../images/default-video-thumbnail.jpeg'
import moment from 'moment'
import { apiUrl } from '../../context/constants/constants'

import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined'
import ColorizeOutlinedIcon from '@mui/icons-material/ColorizeOutlined'

const ResourceItem = ({ post }) => {
  const [thumbnail, setThumbnail] = useState('')
  const downloadImage = (post, title) => {
    const url = apiUrl + '/' + post.files[0].filePath
    // window.location.assign(url, '_blank')
    // window.open(url, '_blank')
    saveAs(url, title) // Put your image URL here.
  }

  const handleClick = async (post) => {
    const url = apiUrl + '/' + post.files[0].filePath
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  useEffect(() => {
    const fileArray = []
    if (post) {
      if (post.files) {
        post.files.forEach((file) => {
          if (
            file.fileType === 'image/jpeg' ||
            file.fileType === 'image/jpg' ||
            file.fileType === 'image/png'
          ) {
            fileArray.push(apiUrl + '/' + file.filePath)
          } else {
            if (post.videoThumbnail && post.videoThumbnail !== '') {
              fileArray.push(apiUrl + '/' + post.videoThumbnail)
            } else {
              fileArray.push(videothumbnail)
            }
          }
        })
      }
      setThumbnail(fileArray.slice(0, 1))
    }
  }, [post])

  return (
    <Card className='card'>
      <div className='buttons'>
        {post.videoThumbnail && post.videoThumbnail !== '' ? (
          <Button onClick={() => handleClick(post)}>
            <DownloadIcon />
          </Button>
        ) : (
          <Button onClick={() => downloadImage(post, post.title)}>
            <DownloadIcon />
          </Button>
        )}
      </div>
      <div className='link'>
        {thumbnail !== '' ? (
          <div>
            {thumbnail.map((file) => (
              <div key={file}>
                <CardMedia
                  className='media'
                  image={file}
                  style={{ width: '286px', height: '137px' }}
                  title={post.title}
                />
                <div className='imgCaption'>
                  <div className='fileTitle'>{post.title}</div>
                  <div className='fileCate'>
                    {post.categoryLocation == 'Laser' ? (
                      <CameraAltOutlinedIcon />
                    ) : (
                      <ColorizeOutlinedIcon />
                    )}{' '}
                    {post.categoryLocation}
                  </div>
                  <div className='overlay'>
                    <Typography variant='body2'>
                      {moment(post.createdAt).fromNow()}
                    </Typography>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div>
            <CardMedia className='media' image={videothumbnail} />
            <div className='imgCaption'>
              <div className='overlay'>
                <Typography variant='body2'>
                  {moment(post.createdAt).fromNow()}
                </Typography>
              </div>
            </div>
          </div>
        )}
      </div>
    </Card>
  )
}

export default ResourceItem
